import Bone from "../../../../Components/Skeleton/Bone"

import styles from "./skeleton.module.less"

const Y_TICKS = 6
const X_TICKS = 7

// A line chart's frame while its series loads: the y ticks, the plot, the x ticks and, where
// the chart draws one, the legend under it, all inside the chart's own height.
const LineChartSkeleton = ({ height, legendItems = 0 }) => (
  <div className={styles.lineChart} style={{ height }}>
    <div className={styles.plot}>
      <div className={styles.yAxis}>
        {Array.from({ length: Y_TICKS }, (_, i) => (
          <Bone key={i} width={32} height={10} />
        ))}
      </div>
      <div className={styles.area}>
        <Bone block height="100%" radius={8} />
      </div>
    </div>
    <div className={styles.xAxis}>
      {Array.from({ length: X_TICKS }, (_, i) => (
        <Bone key={i} width={40} height={10} />
      ))}
    </div>
    {legendItems ? (
      <div className={styles.legend}>
        {Array.from({ length: legendItems }, (_, i) => (
          <span key={i} className={styles.legendItem}>
            <Bone width={8} height={8} radius="50%" />
            <Bone width={72} height={12} />
          </span>
        ))}
      </div>
    ) : null}
  </div>
)

export default LineChartSkeleton
